import { drawStrokesOnContext } from "./pdfCanvasStrokeRender";
import { getBase64FromDataUrl, loadImage } from "./pdfCanvasImageUtils";
import type { PdfCanvasPageMeta, PdfCanvasStroke } from "./pdfCanvasTypes";

export async function renderExportPageCanvas(
    pageMeta: PdfCanvasPageMeta,
    initialDataUrl: string | undefined,
    strokes: PdfCanvasStroke[],
): Promise<HTMLCanvasElement | null> {
    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = pageMeta.width;
    pageCanvas.height = pageMeta.height;
    const ctx = pageCanvas.getContext("2d");
    if (!ctx) {
        return null;
    }

    if (initialDataUrl) {
        const initialImage = await loadImage(initialDataUrl);
        ctx.drawImage(initialImage, 0, 0, pageCanvas.width, pageCanvas.height);
    }

    drawStrokesOnContext(ctx, strokes);
    return pageCanvas;
}

export function mergePageCanvasesToPngBase64(pageCanvasList: HTMLCanvasElement[]): string | null {
    if (pageCanvasList.length === 0) {
        return null;
    }

    const totalHeight = pageCanvasList.reduce((sum, e) => sum + e.height, 0);
    const maxWidth = pageCanvasList.reduce((max, e) => Math.max(max, e.width), 0);
    const mergedCanvas = document.createElement("canvas");
    mergedCanvas.width = maxWidth;
    mergedCanvas.height = totalHeight;
    const mergedCtx = mergedCanvas.getContext("2d");
    if (!mergedCtx) {
        return null;
    }

    let y = 0;
    for (const canvas of pageCanvasList) {
        mergedCtx.drawImage(canvas, 0, y);
        y += canvas.height;
    }

    return getBase64FromDataUrl(mergedCanvas.toDataURL("image/png"));
}

export async function exportAnnotatedPagesToLongPngBase64(
    pageMetaList: PdfCanvasPageMeta[],
    initialPageDataUrlList: string[],
    pageStrokeList: PdfCanvasStroke[][],
): Promise<string | null> {
    if (pageMetaList.length === 0) {
        return null;
    }

    const pageCanvasList: HTMLCanvasElement[] = [];
    for (let i = 0; i < pageMetaList.length; i++) {
        const pageCanvas = await renderExportPageCanvas(
            pageMetaList[i],
            initialPageDataUrlList[i],
            pageStrokeList[i] ?? [],
        );
        if (pageCanvas) {
            pageCanvasList.push(pageCanvas);
        }
    }

    return mergePageCanvasesToPngBase64(pageCanvasList);
}
